<template>
  <b-modal
    ref="modal"
    static
    :visible="show"
    :title="modalTitle"
    header-bg-variant="light"
    @hidden="resetForm"
    @close="close"
    @cancel="close"
    @ok.prevent="handleSubmit"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    centered
  >
    <b-form @submit.prevent="handleSubmit" ref="form">
      <b-form-group
        label="Mã:"
        label-for="code-input"
        :state="isValidCode"
        :invalid-feedback="codeInvalidFeedback"
      >
        <b-form-input
          id="code-input"
          v-model="form.code"
          :state="isValidCode"
          required
          placeholder="Nhập mã loại dịch vụ"
          maxlength="50"
          :disabled="isSubmitting"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="Tên:"
        label-for="name-input"
        :state="isValidName"
        :invalid-feedback="nameInvalidFeedback"
      >
        <b-form-input
          id="name-input"
          v-model="form.name"
          :state="isValidName"
          required
          placeholder="Nhập tên loại dịch vụ"
          maxlength="255"
          :disabled="isSubmitting"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-for="active-input">
        <b-form-checkbox
          id="active-input"
          v-model="form.isActive"
          :disabled="isSubmitting"
          switch
        >
          {{ form.isActive ? 'Hoạt động' : 'Không hoạt động' }}
        </b-form-checkbox>
      </b-form-group>
    </b-form>

    <template #modal-footer="{ ok, cancel }">
      <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
        Hủy bỏ
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSubmitting || !isFormValid"
        @click="handleSubmit"
      >
        <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
        {{ isEdit ? 'Cập nhật' : 'Thêm mới' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { WarrantyServiceService } from './service/warranty-service.service';
import { makeToastSuccess, handleError } from '@/utils/common';

export default {
  name: 'WarrantyServiceFormModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    warrantyService: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        code: '',
        name: '',
        isActive: true,
      },
      validationErrors: {
        code: '',
        name: '',
      },
    };
  },
  computed: {
    modalTitle() {
      return this.isEdit
        ? `Chỉnh sửa loại dịch vụ: ${this.warrantyService?.name || ''}`
        : 'Thêm mới loại dịch vụ';
    },
    isValidCode() {
      return this.validationErrors.code ? false : null;
    },
    isValidName() {
      return this.validationErrors.name ? false : null;
    },
    codeInvalidFeedback() {
      return this.validationErrors.code;
    },
    nameInvalidFeedback() {
      return this.validationErrors.name;
    },
    isFormValid() {
      return !!this.form.code && !!this.form.name;
    },
  },
  watch: {
    warrantyService(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.warrantyService) {
        this.form = {
          ...this.form,
          ...this.warrantyService,
          isActive: Boolean(this.warrantyService.isActive),
        };
      }
    },
    resetForm() {
      this.form = {
        code: '',
        name: '',
        isActive: true,
      };
      this.validationErrors = {
        code: '',
        name: '',
      };
    },
    validateForm() {
      this.validationErrors = {
        code: '',
        name: '',
      };

      if (!this.form.code.trim()) {
        this.validationErrors.code = 'Mã loại dịch vụ không được để trống';
      }

      if (!this.form.name.trim()) {
        this.validationErrors.name = 'Tên loại dịch vụ không được để trống';
      }

      return !this.validationErrors.code && !this.validationErrors.name;
    },
    handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = {
        code: this.form.code.trim(),
        name: this.form.name.trim(),
        isActive: Boolean(this.form.isActive),
      };

      const request = this.isEdit
        ? WarrantyServiceService.update(this.warrantyService.id, payload)
        : WarrantyServiceService.create(payload);

      request
        .then((response) => {
          const message = this.isEdit
            ? 'Cập nhật loại dịch vụ thành công!'
            : 'Thêm mới loại dịch vụ thành công!';

          makeToastSuccess(message);
          this.$emit('warranty-service-saved', response.data.data);
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.isSubmitting = false;
          if (!Object.values(this.validationErrors).some((v) => v)) {
            this.close();
          }
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
